import { MicrosoftIcon } from './MicrosoftIcon';

/**
 * Props for the SignupCta dark CTA card.
 */
interface SignupCtaProps {
  /** Card headline (e.g. "Ready when you are"). */
  headline: string;
  /** Sub-headline that explains the Microsoft Entra handoff. */
  subhead: string;
  /** Label for the primary email-signup button. */
  signUpEmailLabel: string;
  /** Label for the secondary Microsoft-signup button. */
  signUpMicrosoftLabel: string;
  /** Accessible label for the Microsoft icon. */
  microsoftIconAlt: string;
  /** Click handler for the email signup button. */
  onSignUpEmail: () => void;
  /** Click handler for the Microsoft signup button. */
  onSignUpMicrosoft: () => void;
}

/**
 * Dark card containing the Entra disclaimer and the two signup CTAs
 * (email primary, Microsoft secondary). Buttons stack vertically on mobile.
 */
export function SignupCta({
  headline,
  subhead,
  signUpEmailLabel,
  signUpMicrosoftLabel,
  microsoftIconAlt,
  onSignUpEmail,
  onSignUpMicrosoft,
}: SignupCtaProps) {
  return (
    <section
      className="rounded-[14px] p-7 sm:p-9"
      style={{ backgroundColor: '#242424' }}
    >
      <h2
        className="text-[22px] font-semibold text-white"
        style={{ fontFamily: '"Urbanist", "Helvetica", sans-serif' }}
      >
        {headline}
      </h2>
      <p
        className="mt-3 text-[15px] text-white/65"
        style={{
          fontFamily: '"Urbanist", "Helvetica", sans-serif',
          lineHeight: 1.55,
        }}
      >
        {subhead}
      </p>

      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        {/* Primary: Sign up with email — yellow pill */}
        <button
          type="button"
          onClick={onSignUpEmail}
          className="flex-1 inline-flex items-center justify-center px-6 py-3 text-[13px] font-bold uppercase rounded-full bg-[#f5ea29] text-[#242424] hover:bg-[#e0d600] transition-colors cursor-pointer"
          style={{
            fontFamily: '"Urbanist", "Helvetica", sans-serif',
            letterSpacing: '0.5px',
          }}
        >
          {signUpEmailLabel}
        </button>

        {/* Secondary: Sign up with Microsoft — outline pill with MS icon */}
        <button
          type="button"
          onClick={onSignUpMicrosoft}
          className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 text-[13px] font-bold uppercase rounded-full bg-transparent text-white border border-white/40 hover:bg-white/10 transition-colors cursor-pointer"
          style={{
            fontFamily: '"Urbanist", "Helvetica", sans-serif',
            letterSpacing: '0.5px',
          }}
        >
          <MicrosoftIcon size={16} title={microsoftIconAlt} />
          <span>{signUpMicrosoftLabel}</span>
        </button>
      </div>
    </section>
  );
}
